import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stats-ai-mode-toggle',
  standalone: true,
  templateUrl: './stats-ai-mode-toggle.component.html',
  styleUrls: ['./stats-ai-mode-toggle.component.scss']
})
export class StatsAiModeToggleComponent {
  @Input() mode: 'actas' | 'ia' = 'actas';
  @Output() modeChange = new EventEmitter<'actas' | 'ia'>();

  toggleMode(newMode: 'actas' | 'ia') {
    if (this.mode !== newMode) {
      this.mode = newMode;
      this.modeChange.emit(this.mode);
    }
  }
}
